import { View as CalendarView } from "react-big-calendar";
import moment from "moment";
import LeftCalendar from "../../../assets/images/LeftCalendar.svg"
import RightCalendar from "../../../assets/images/RightCalendar.svg"


const CustomToolbar = ({ date, view, onView, onNavigate }: any) => {
    const monthLabel = moment(date).format("MMMM YYYY");

    // const rangeLabel =
    //     view === "month"
    //         ? `${moment(date).startOf("month").startOf("week").format("D MMM")} – ${moment(date)
    //             .endOf("month")
    //             .endOf("week")
    //             .format("D MMM")}`
    //         : moment(date).format("D MMM YYYY");

    const rangeLabel =
        view === "month"
            ? `${moment(date).startOf("month").format("D MMM")} – ${moment(date).endOf("month").format("D MMM")}`
            : view === "week"
                ? `${moment(date).startOf("week").format("D MMM")} – ${moment(date).endOf("week").format("D MMM")}`
                : moment(date).format("D MMM YYYY");


    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between pb-3 gap-4">
            {/* LEFT: Month label */}
            <div className="bg-transparent font-[Poppins] font-medium text-[18px] leading-[100%] text-black whitespace-nowrap">
                {monthLabel}
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 w-full sm:w-auto">
                <div
                    className="flex items-center gap-2 px-3 py-2 rounded font-[Poppins] font-normal text-[15px] leading-[18px] text-center text-[#364153] calender-navigator w-full sm:w-auto justify-center"
                >
                    <button
                        onClick={() => onNavigate("PREV")}
                        className="p-1 rounded hover:opacity-80 transition"
                    >
                        {/* Replace src with your image */}
                        <img src={LeftCalendar} alt="Previous" className="w-5 h-5" />
                    </button>

                    <span className="whitespace-nowrap">{rangeLabel}</span>

                    <button
                        onClick={() => onNavigate("NEXT")}
                        className="p-1 rounded hover:opacity-80 transition"
                    >
                        {/* Replace src with your image */}
                        <img src={RightCalendar} alt="Next" className="w-5 h-5" />
                    </button>
                </div>

                <div className="flex bg-[#F4F4F4] rounded-[5.06px] p-[5.02px] w-full sm:w-auto">
                    {(["month", "week", "day"] as CalendarView[]).map(v => {
                        const isActive = view === v;

                        return (
                            <button
                                key={v}
                                onClick={() => onView(v)}
                                style={
                                    isActive
                                        ? {
                                            boxShadow:
                                                "0px 1.26px 2.51px -1.26px #0000001A, 0px 1.26px 3.77px 0px #0000001A",
                                        }
                                        : undefined
                                }
                                className={`
          px-3 sm:px-4 py-1.5 rounded-[5.06px] transition
          font-[Poppins] font-normal
          text-[14px] sm:text-[15px] leading-[30.14px]
          text-center capitalize
          ${isActive
                                        ? "bg-[#FFFFFF] text-[#7E57C2]"
                                        : "bg-transparent text-[#747474]"
                                    }
          flex-1 sm:flex-none
        `}
                            >
                                {v}
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default CustomToolbar;